// import Inbox from './components/Inbox'
const Index = () => import( /* webpackChunkName: "home" */ './index.vue');
const Student = () => import( /* webpackChunkName: "home" */ '@/modules/Students/Profile.vue');
const ClassRoom = () => import( /* webpackChunkName: "home" */ '@/modules/Home/components/AddStudentToClass.vue');
const Attendance = () => import( /* webpackChunkName: "home" */ '@/modules/Attendance/Create.vue');
const Report = () => import( /* webpackChunkName: "home" */ '@/modules/Attendance/Report.vue');
const Tools = () => import( /* webpackChunkName: "home" */ '@/modules/Home/components/Tools.vue');
const Year = () => import( /* webpackChunkName: "home" */ '@/modules/Year/List.vue');
const GradeEntry = () => import( /* webpackChunkName: "home" */ '@/modules/Grades/Create.vue');
const TimeOff = () => import( /* webpackChunkName: "time-off" */ '@/modules/TimeOff/index.vue');
// import Attendance from '@/modules/TeacherModules/Attendance/Create.vue'
// let routes = [];
// routes = routes.concat(CategoryRoutes);

export default [
  {
    path: '/time-off',
    name: 'teacher-time-off',
    component: TimeOff,
    title: 'Time-Off Requests',
  },
  {
    path: '/',
    name: 'home',
    component: Index,
    title: 'Home',
  },
  {
    path: '/s/profile',
    name: 'student-profile',
    component: Student,
    props: true,
    title: 'Student',
  },
  {
    path: '/room',
    name: 'add-student-to-class-room',
    component: ClassRoom,
    props: true,
    title: 'Class Room',
  },
  {
    path: '/attendance',
    name: 'class-room-attendance',
    component: Attendance,
    props: true,
    title: 'Class Room Attendance',
  },
  {
    path: '/report',
    name: 'class-room-report',
    component: Report,
    props: true,
    title: 'Report',
  },
  {
    path: '/tools',
    name: 'tools',
    component: Tools,
    props: true,
    title: 'Tools',
  },
  {
    path: '/reportCard/grades',
    name: 'years',
    component: Year,
    props: true,
    title: 'Year',
  },
  {
    path: '/reportCard/grades/:yearId',
    name: 'grade-entry',
    component: GradeEntry,
    props: true,
    title: 'Enter Grades',
  },
];
